export default {
  'escort.dashboard.welcome': "Bienvenue",
  'escort.dashboard.dashboard_description': "Gérez votre profil, consultez les statistiques et accédez aux actions rapides.",
  'escort.dashboard.profile_views': "Vues du profil",
  'escort.dashboard.new_messages': "Nouveaux messages",
  'escort.dashboard.pending_bookings': "Réservations en attente",
  'escort.dashboard.weekly_income': "Revenu hebdomadaire",
  'escort.dashboard.profile_completion': "Achèvement du profil",
  'escort.dashboard.profile_completion_description': "Complétez votre profil pour attirer plus de clients.",
  'escort.dashboard.complete_profile': "Compléter le profil",
  'escort.dashboard.edit_profile': "Modifier le profil",
  'escort.dashboard.media_manager': "Gestionnaire de médias",
  'escort.dashboard.manage_photos_videos': "Gérer les photos et vidéos",
  'escort.dashboard.security_settings': "Paramètres de sécurité",
  'escort.dashboard.update_password_preferences': "Mettre à jour le mot de passe et les préférences",
  'escort.dashboard.payout_details': "Détails de paiement",
  'escort.dashboard.add_bank_account_details': "Ajouter les détails du compte bancaire",
  'escort.dashboard.verification_center': "Centre de vérification",
  'escort.dashboard.verify_identity_documents': "Vérifier les documents d'identité",
  'escort.dashboard.earnings_overview': "Aperçu des gains",
  'escort.dashboard.track_income_performance': "Suivre les revenus et les performances",
  'escort.dashboard.analytics_insights': "Aperçu des analyses",
  'escort.dashboard.understand_profile_performance': "Comprendre les performances du profil",
  'escort.dashboard.customer_feedback': "Commentaires des clients",
  'escort.dashboard.read_reviews_improve_services': "Lire les avis et améliorer les services",
  'escort.dashboard.support_center': "Centre de support",
  'escort.dashboard.get_help_support_assistance': "Obtenir de l'aide et une assistance",
  'escort.dashboard.logout': "Se déconnecter",
  'escort.dashboard.logout_from_platform': "Se déconnecter de la plateforme",
  'escort.dashboard.profile_visibility': "Visibilité du profil",
  'escort.dashboard.profile_visibility_description': "Choisissez qui peut voir votre profil.",
  'escort.dashboard.profile_status': "Statut du profil",
  'escort.dashboard.profile_status_description': "Définissez votre profil comme visible ou invisible.",
  'escort.dashboard.online_status': "Statut en ligne",
  'escort.dashboard.online_status_description': "Indiquez si vous êtes actuellement en ligne ou hors ligne.",
  'escort.dashboard.title': "Tableau de bord d'escorte",
  'escort.dashboard.navigation': "Navigation",
  'escort.dashboard.overview': "Vue d'ensemble",
  'escort.dashboard.profile': "Profil",
  'escort.dashboard.messages': "Messages",
  'escort.dashboard.bookings': "Réservations",
  'escort.dashboard.calendar': "Calendrier",
  'escort.dashboard.media': "Médias",
  'escort.dashboard.finances': "Finances",
  'escort.dashboard.premium': "Premium",
  'escort.dashboard.security': "Sécurité",
  'escort.dashboard.verification_status': "Statut de vérification",
  'escort.dashboard.availability': "Disponibilité",
  'escort.dashboard.manage_availability': "Gérer la disponibilité",
  'escort.dashboard.quick_actions': "Actions rapides",
  'escort.dashboard.view_messages': "Voir les messages",
  'escort.dashboard.check_bookings': "Vérifier les réservations",
  'escort.dashboard.add_photos': "Ajouter des photos",
  'escort.dashboard.view_public_profile': "Voir le profil public",
  'escort.dashboard.boost_visibility': "Booster la visibilité",
  'escort.dashboard.visibility': "Visibilité",
  'escort.dashboard.access_denied': "Accès refusé",
  'escort.dashboard.escort_only': "Cette page est réservée aux escortes",
  'escort.dashboard.login_required': "Connexion requise",
  'escort.dashboard.please_login': "Veuillez vous connecter pour accéder à cette page",
  'escort.dashboard.error_loading_profile': "Erreur lors du chargement du profil",
  'escort.dashboard.try_again_later': "Veuillez réessayer plus tard",

  'escort.profile.title': "Profil d'escorte",
  'escort.profile.manage_profile': "Gérer le profil",
  'escort.profile.profile_description': "Modifiez vos informations, services, tarifs et autres détails.",
  'escort.profile.basic_info': "Infos de base",
  'escort.profile.services': "Services",
  'escort.profile.rates': "Tarifs",
  'escort.profile.visibility': "Visibilité",
  'escort.profile.ai.tab_title': "Assistant IA",
  'escort.profile.error_loading': "Erreur de chargement du profil",
  'escort.profile.try_again_later': "Veuillez réessayer plus tard",
  'escort.profile.unable_to_load_or_create': "Impossible de charger ou de créer le profil pour le moment.",
  'escort.profile.edit_profile': "Modifier le profil",
  'escort.profile.preview_profile': "Aperçu du profil",
  'escort.profile.save_changes': "Enregistrer les modifications",
  'escort.profile.cancel': "Annuler",
  'escort.profile.general_information': "Informations générales",
  'escort.profile.create_profile_title': "Créer votre profil d'escorte",
  'escort.profile.create_profile_desc': "Remplissez les informations ci-dessous pour commencer.",
  'escort.profile.creation_success_title': "Profil créé avec succès",
  'escort.profile.creation_success_desc': "Votre profil d'escorte a été créé.",
  'escort.profile.creation_error_title': "Erreur de création",
  'escort.profile.creation_missing_fields': "Veuillez remplir tous les champs obligatoires (*)",
  'escort.profile.personal_details': "Détails personnels",
  'escort.profile.start_by_filling_info': "Commencez par remplir vos informations personnelles.",
  'escort.profile.display_name': "Nom d'affichage",
  'escort.profile.display_name_placeholder': "Votre nom d'affichage public",
  'escort.profile.display_name_description': "Le nom que les utilisateurs verront.",
  'escort.profile.age': "Âge",
  'escort.profile.age_description': "Votre âge sera automatiquement calculé.",
  'escort.profile.gender': "Genre",
  'escort.profile.select_gender': "Sélectionnez votre genre",
  'escort.profile.gender_description': "Votre genre.",
  'escort.profile.orientation': "Orientation",
  'escort.profile.select_orientation': "Sélectionnez votre orientation",
  'escort.profile.orientation_description': "Votre orientation.",
  'escort.profile.location': "Emplacement",
  'escort.profile.location_description': "Votre emplacement.",
  'escort.profile.city': "Ville",
  'escort.profile.city_placeholder': "Votre ville",
  'escort.profile.country': "Pays",
  'escort.profile.country_placeholder': "Votre pays",
  'escort.profile.appearance': "Apparence",
  'escort.profile.physical_attributes': "Attributs physiques",
  'escort.profile.ethnicity': "Ethnicité",
  'escort.profile.select_ethnicity': "Sélectionnez votre ethnicité",
  'escort.profile.ethnicity_description': "Votre ethnicité.",
  'escort.profile.height': "Taille",
  'escort.profile.height_cm': "Taille (cm)",
  'escort.profile.height_description': "Votre taille.",
  'escort.profile.weight': "Poids",
  'escort.profile.weight_kg': "Poids (kg)",
  'escort.profile.weight_description': "Votre poids.",
  'escort.profile.body_type': "Type de corps",
  'escort.profile.select_body_type': "Sélectionnez votre type de corps",
  'escort.profile.body_type_description': "Votre type de corps.",
  'escort.profile.hair_color': "Couleur des cheveux",
  'escort.profile.hair_color_placeholder': "ex: Brun, Blond, Roux...",
  'escort.profile.hair_color_description': "Votre couleur de cheveux.",
  'escort.profile.eye_color': "Couleur des yeux",
  'escort.profile.eye_color_placeholder': "ex: Bleu, Vert, Marron...",
  'escort.profile.eye_color_description': "Votre couleur des yeux.",
  'escort.profile.nationality': "Nationalité",
  'escort.profile.nationality_placeholder': "Votre nationalité",
  'escort.profile.details': "Détails",
  'escort.profile.bio': "Bio",
  'escort.profile.bio_short': "Bio courte",
  'escort.profile.bio_short_placeholder': "Une phrase d'accroche (max 150 caractères)",
  'escort.profile.bio_short_description': "Une courte description de vous-même.",
  'escort.profile.bio_full': "Bio complète",
  'escort.profile.bio_full_placeholder': "Décrivez-vous plus en détail",
  'escort.profile.bio_long': "Bio longue",
  'escort.profile.bio_long_description': "Une description plus détaillée de vous-même.",
  'escort.profile.sexual_orientation': "Orientation sexuelle",
  'escort.profile.create_profile_button': "Créer le profil",
  'escort.profile.services_description': "Les services que vous offrez.",
  'escort.profile.additional_details': "Détails supplémentaires",
  'escort.profile.availability_description': "Votre disponibilité.",
  'escort.profile.photos': "Photos",
  'escort.profile.photos_description': "Téléchargez et gérez vos photos de profil.",
  'escort.profile.videos': "Vidéos",
  'escort.profile.videos_description': "Vos vidéos.",
  'escort.profile.premium_content': "Contenu premium",
  'escort.profile.premium_content_description': "Votre contenu premium.",
  'escort.profile.verification': "Vérification",
  'escort.profile.verification_description': "Votre vérification.",
  'escort.profile.account': "Compte",
  'escort.profile.account_description': "Votre compte.",
  'escort.profile.security': "Sécurité",
  'escort.profile.security_description': "Votre sécurité.",
  'escort.profile.payout': "Paiement",
  'escort.profile.payout_description': "Votre paiement.",
  'escort.profile.settings': "Paramètres",
  'escort.profile.settings_description': "Vos paramètres.",
  'escort.profile.logout': "Se déconnecter",
  'escort.profile.logout_description': "Se déconnecter.",
  'escort.profile.save': "Enregistrer",
  'escort.profile.cancel_edit': "Annuler la modification",
  'escort.profile.profile_information': "Informations du profil",
  'escort.profile.describe_yourself': "Décrivez-vous",
  'escort.profile.services_offered': "Services offerts",
  'escort.profile.hourly_rate': "Tarif horaire",
  'escort.profile.additional_information': "Informations supplémentaires",
  'escort.profile.general': "Général",
  'escort.profile.media': "Média",
  'escort.profile.manage_photos': "Gérer les photos",
  'escort.profile.upload_photo': "Télécharger une photo",
  'escort.profile.no_photos': "Vous n'avez pas encore de photos.",
  'escort.profile.upload_first_photo': "Télécharger votre première photo",
  'escort.profile.profile_photo': "Photo de profil",
  'escort.profile.main': "Principal",
  'escort.profile.private': "Privé",
  'escort.profile.delete': "Supprimer",
  'escort.profile.set_main': "Définir comme principal",
  'escort.profile.photo_visibility_updated': "Visibilité de la photo mise à jour",
  'escort.profile.photo_now_public': "La photo est maintenant publique",
  'escort.profile.photo_now_private': "La photo est maintenant privée",
  'escort.profile.private_visibility': "Visibilité privée",
  'escort.profile.public_visibility': "Visibilité publique",
  'escort.profile.error_loading_photos': "Erreur lors du chargement des photos",
  'escort.profile.photo_uploaded': "Photo téléchargée",
  'escort.profile.photo_upload_success': "La photo a été téléchargée avec succès",
  'escort.profile.upload_error': "Erreur de téléchargement",
  'escort.profile.photo_deleted': "Photo supprimée",
  'escort.profile.photo_delete_success': "La photo a été supprimée avec succès",
  'escort.profile.delete_error': "Erreur de suppression",
  'escort.profile.main_photo_updated': "Photo principale mise à jour",
  'escort.profile.main_photo_update_success': "La photo principale a été mise à jour avec succès",
  'escort.profile.update_error': "Erreur de mise à jour",
  'escort.profile.storage_unavailable': "Stockage indisponible",
  'escort.profile.storage_unavailable_message': "Le service de stockage est actuellement indisponible. Vous ne pourrez pas télécharger d'images pour le moment. Veuillez réessayer plus tard ou contacter le support si ce problème persiste.",
  'escort.profile.contact_support': "Veuillez contacter le support",
  'escort.profile.manage_videos': "Gérer les vidéos",
  'escort.profile.upload_video': "Télécharger une vidéo",
  'escort.profile.no_videos': "Vous n'avez pas encore de vidéos.",
  'escort.profile.upload_first_video': "Télécharger votre première vidéo",
  'escort.profile.video_uploaded': "Vidéo téléchargée",
  'escort.profile.video_upload_success': "La vidéo a été téléchargée avec succès",
  'escort.profile.video_deleted': "Vidéo supprimée",
  'escort.profile.video_delete_success': "La vidéo a été supprimée avec succès",
  'escort.profile.manage_premium_content': "Gérer le contenu premium",
  'escort.profile.upload_premium': "Télécharger du contenu premium",
  'escort.profile.no_premium_content': "Vous n'avez pas encore de contenu premium.",
  'escort.profile.upload_first_premium_content': "Télécharger votre premier contenu premium",
  'escort.profile.premium_content_uploaded': "Contenu premium téléchargé",
  'escort.profile.premium_content_upload_success': "Le contenu premium a été téléchargé avec succès",
  'escort.profile.premium_content_deleted': "Contenu premium supprimé",
  'escort.profile.premium_content_delete_success': "Le contenu premium a été supprimé avec succès",
  'escort.profile.subscription_required': "Abonnement requis",
  'escort.profile.subscription_unlock': "Abonnez-vous pour débloquer le contenu privé",
  'escort.profile.subscribe': "S'abonner",
  'escort.profile.profile_visitors': "Visiteurs du profil",
  'escort.profile.profile_likes': "J'aime du profil",
  'escort.profile.profile_shares': "Partages du profil",
  'escort.profile.profile_saves': "Sauvegardes du profil",
  'escort.profile.profile_messages': "Messages du profil",
  'escort.profile.profile_bookings': "Réservations du profil",
  'escort.profile.profile_reviews': "Avis du profil",
  'escort.profile.profile_ratings': "Évaluations du profil",
  'escort.profile.profile_earnings': "Gains du profil",
  'escort.profile.profile_balance': "Solde du profil",
  'escort.profile.profile_payouts': "Paiements du profil",
  'escort.profile.profile_verification': "Vérification du profil",
  'escort.profile.profile_verification_status': "Statut de vérification du profil",
  'escort.profile.profile_verification_description': "Vérifiez votre profil pour gagner la confiance des clients.",
  'escort.profile.profile_verification_documents': "Documents de vérification du profil",
  'escort.profile.profile_verification_identity': "Vérification de l'identité du profil",
  'escort.profile.profile_verification_address': "Vérification de l'adresse du profil",
  'escort.profile.profile_verification_phone': "Vérification du téléphone du profil",
  'escort.profile.profile_verification_email': "Vérification de l'email du profil",
  'escort.profile.profile_verification_social': "Vérification des réseaux sociaux du profil",
  'escort.profile.profile_account_settings': "Paramètres du compte du profil",
  'escort.profile.profile_account_email': "Email du compte du profil",
  'escort.profile.profile_account_password': "Mot de passe du compte du profil",
  'escort.profile.profile_account_preferences': "Préférences du compte du profil",
  'escort.profile.profile_security_settings': "Paramètres de sécurité du profil",
  'escort.profile.profile_security_password': "Mot de passe de sécurité du profil",
  'escort.profile.profile_security_two_factor': "Authentification à deux facteurs de sécurité du profil",
  'escort.profile.profile_security_sessions': "Sessions de sécurité du profil",
  'escort.profile.profile_payout_settings': "Paramètres de paiement du profil",
  'escort.profile.profile_payout_method': "Méthode de paiement du profil",
  'escort.profile.profile_payout_details': "Détails de paiement du profil",
  'escort.profile.profile_payout_history': "Historique des paiements du profil",
  'escort.profile.profile_support_center': "Centre de support du profil",
  'escort.profile.profile_support_faq': "FAQ du support du profil",
  'escort.profile.profile_support_contact': "Contact du support du profil",
  'escort.profile.profile_support_report': "Rapport du support du profil",
  'escort.profile.profile_support_feedback': "Commentaires du support du profil",
};

